// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-10botns-MuiInputBase-input-MuiFilledInput-input {
  padding-bottom: 13px !important;
}

.reset-account-textfield .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  width: 254px !important;
  height: 7vh !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Account/style.scss"],"names":[],"mappings":"AACI;EACI,+BAAA;AAAR;;AAKI;EACI,uBAAA;EACA,sBAAA;AAFR","sourcesContent":["// .Account-Textfield{\r\n    .css-10botns-MuiInputBase-input-MuiFilledInput-input{\r\n        padding-bottom: 13px !important;\r\n    }\r\n// }\r\n\r\n.reset-account-textfield{\r\n    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\r\n        width: 254px !important;\r\n        height:7vh !important;\r\n    }\r\n   \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
